// extracted by mini-css-extract-plugin
export default {"title":"lt2xrV","name":"lRAKNN","description":"Mfzr7N","short":"Yav4ch","wrapper":"Sllesl","link":"mQnC_r","period":"St_OfM"};